import { render, staticRenderFns } from "./ItemText.vue?vue&type=template&id=1fb3db5c&scoped=true"
import script from "./ItemText.vue?vue&type=script&lang=js"
export * from "./ItemText.vue?vue&type=script&lang=js"
import style0 from "./ItemText.vue?vue&type=style&index=0&id=1fb3db5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb3db5c",
  null
  
)

export default component.exports